/* eslint-disable jsx-a11y/anchor-is-valid */
import { Layout, Row, Col, Button, Typography } from "antd";
import { BellFilled, LeftOutlined } from "@ant-design/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import styles from "./styles/AppContainer.module.css";

import AppContainerSubHeader from "~v2/components/AppContainerSubHeader/AppContainerSubHeader";
import AppContainerFooter from "~v2/components/AppContainerFooter/AppContainerFooter";

const { Header, Content, Footer } = Layout;
const { Paragraph } = Typography;

const AppContainer = ({ title, children, onBackEvent = () => {} }) => {
  const { firstname, lastname, userlevel } = useSelector((state) => state.users);
  const navigate = useNavigate();


  return (
    <Layout className={styles.layout}>
      <Header className={styles.header}>
        <Row className={styles.paddedRow}>
          <Col span={20}>
            <>
             
                <>
                  <Paragraph style={{ fontSize: 20, margin: "5px 0 0 0" }}>
                    Welcome, {firstname} {lastname}
                  </Paragraph>
                  <Paragraph style={{ margin: "0 0 10px 0" }}>
                    User Level: {userlevel}
                  </Paragraph>
                </>
             
            </>
          </Col>

          <Col span={4} className={styles.notificationContainer}>
            <BellFilled
              onClick={() => navigate("../notification")}
              style={{ fontSize: 45, marginBottom: 10 }}
            />
          </Col>
        </Row>
        {title && <AppContainerSubHeader />}
      </Header>
      <Content className={styles.content}>
        {title && (
          <Row>
            <Col
              span={24}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderBottom: "gray solid 1px",
                padding: "10px 0px",
              }}
            >
              <Button
                onClick={() => {
                  navigate(-1);
                }}
                style={{
                  float: "left",
                  border: "0px",
                  background: "transparent",
                  boxShadow: "none",
                  color: "green",
                }}
                transparent
                icon={<LeftOutlined />}
              />
              <b style={{ flex: 1, textAlign: "center", fontSize: "20px" }}>
                {title.toUpperCase()}
              </b>
              <div style={{ clear: "both" }} />
            </Col>
          </Row>
        )}
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          {children}
        </div>
      </Content>
      <Footer className={styles.footer}>
        <AppContainerFooter />
      </Footer>
    </Layout>
  );
};

export default AppContainer;
